import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

type BreadcrumbItem = {
    label: string;
    path?: string;
    onClick?: () => void;
};

interface AppBreadcrumbsProps {
    items: BreadcrumbItem[];
}

const AppBreadcrumbs: React.FC<AppBreadcrumbsProps> = ({ items }) => {
    const navigate = useNavigate();

    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
                fontSize: '12px',
                marginBottom: "16px",
                '& .MuiLink-root': { fontSize: '12px', cursor: 'pointer' },
                '& .MuiTypography-root': { fontSize: '12px' }
            }}
        >
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                if (isLast) {
                    return (
                        <Typography key={index} color="text.primary">
                            {item.label}
                        </Typography>
                    );
                }

                const handleClick = () => {
                    if (item.onClick) {
                        item.onClick();
                    } else if (item.path) {
                        navigate(item.path);
                    }
                };

                return (
                    <Link
                        key={index}
                        underline="hover"
                        color="inherit"
                        onClick={handleClick}
                    >
                        {item.label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default AppBreadcrumbs;